import { Hidden, Pagination, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
import TocIcon from '@mui/icons-material/Toc';
import { useState } from "react";
import CarType from "../../interfaces/car";
import CardSearchList from "./CardSearchList";
import TableSearch from "./TableSearch";

export default function Search() {
    const { t } = useTranslation();
    const [showType, setShowType] = useState('card');
    const [cars, setCars] = useState<CarType[]>([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPage] = useState(0);
    const [loading, setLoading] = useState(true);

    const handleChangePage = (_: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const handleChangeShowType = (_: any, newValue: string) => {
        if (newValue) {
            setShowType(newValue)
        }
    }
    return (
        <div className="max-w-4xl mx-4 md:mx-auto">
            <Outlet context={{ setCars, page, setPage, setLoading, setTotalPage, loading }} />
            <div className="flex flex-row justify-between items-center mb-6">
                <Hidden smDown>
                    <Typography>{t('show_result_by')}</Typography>
                </Hidden>
                <ToggleButtonGroup size="small" color="secondary" exclusive onChange={handleChangeShowType} value={showType} className="flex flex-row justify-between sm:justify-normal sm:gap-4">
                    <ToggleButton value='card'><DashboardIcon /></ToggleButton>
                    <ToggleButton value='table'><TocIcon /></ToggleButton>
                </ToggleButtonGroup>
            </div>
            {
                showType === 'card' && <CardSearchList cars={cars} loading={loading} />
            }
            {

                showType === 'table' && <TableSearch cars={cars} loading={loading} />
            }
            {
                totalPages > 0 && <div className="flex justify-center mt-6">
                    <Pagination className="mx-auto" color="primary" onChange={handleChangePage} count={totalPages} shape="rounded" />
                </div>
            }

        </div>
    )
}
